import React from 'react';

function HTZAPolicy() {
    return (
        <div className="p-8 max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">Bundu – Privacy Policy</h1>
            <p className="text-sm text-gray-600">Privacy policy coming soon.</p>
        </div>
    );
}

export default HTZAPolicy;
